export default "__VITE_ASSET__BfIaA7nW__"